import { Box, Button, styled } from "@mui/material";
import React from "react";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";

interface VideoButtonInterface {
    title: string;
    externalLink?: string;    // YouTube external link
    size?: string;
    noRightSpace?: boolean;
}

const VideoButtonContainer = styled(Box)({
    position: "relative",
    display: "flex",
    justifyContent: "center",
});

const TopSectionButton = styled(Button)({
    position: "relative",
    zIndex: 2,
    cursor: "pointer",
    textTransform: "none",
    display: "flex",
    gap: "10px",
    background: "linear-gradient(90deg,#df5b4f,#72313d)",
    borderRadius: "50px",
    padding: "15px 40px",
    fontWeight: 800,
    color: "#FFF",
    fontSize: "1.6rem",
    transition: "background 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55), transform 0.5s ease-out",
    "&:hover": {
        background: "linear-gradient(45deg, #ffc371, #ff5f6d)",
        boxShadow: "0 0 15px #ffc371",
        transform: "scale(1.05)",
    },
    "&.noRightSpace": {
        transform: "translateX(-55px)",
    },
    "&.small": {
        fontSize: "1rem",
    },
    "&.openDownloadButton": {
        transform: "translateX(-25%)",
        "&.noRightSpace": {
            transform: "translateX(-155px)",
        },
    },
    "@media(max-width: 768px)": {
        fontSize: ".8rem",
        "&.small": {
            margin: "auto"
        },
    }
});


const LinkButton = ({ title, externalLink }: VideoButtonInterface): JSX.Element => {
    const onExternalLink = (): void => {
        window.open(externalLink, "_blank");
    };
    
    return (
        <VideoButtonContainer>
            <TopSectionButton onClick={onExternalLink}>
                <PrecisionManufacturingIcon htmlColor={"#FFFFFF"} />
                {title}
            </TopSectionButton>
        </VideoButtonContainer>
    );
};

export default LinkButton;
